import React from "react";
import { useTranslation } from "react-i18next";
import { RemoveIcon } from "@common/assets/removeIcon";
import { Props } from "./types";
import styles from "./styles.scss";

// Everyone is sent to the back at validation: it stands for the whole list, which is never loaded.
function SelectedEveryone({ unSelect }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.selectedEveryone}>
      <div className={styles.resource}>
        <p>{t("common.filterMenu.resources.everyone")}</p>
      </div>
      <div className={styles.removeButton} onClick={unSelect}>
        <RemoveIcon className={styles.removeIcon} />
      </div>
    </div>
  );
}

export { SelectedEveryone };
